import { PrivacyPolicyModel } from 'shared/api/PrivacyPolicyModel.ts'
import { Response } from 'shared/models/general.ts'

import { clientApi } from './clientApi'

export const PrivacyPolicyApi = {
  getPolicy() {
    return clientApi.get<Response<PrivacyPolicyModel>>('/privacy_terms')
  },
}
